var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { issue, toErrorLines } from './issues';
import { formatJsonParseError, locateJsonError } from './jsonLocate';
import { validateSceneJSON } from './scene';
/**
 * Parse a JSON string and validate it as Scene JSON.
 * Parse failures include line/column + caret; schema failures include paths + expected values.
 */
export function parseAndValidateSceneJSON(raw, options) {
    var source = typeof raw === 'string' ? raw : String(raw);
    if (!source.trim()) {
        var issues = [issue('root', 'empty JSON — paste a scene object', 'empty')];
        return {
            json: null,
            validation: { valid: false, errors: toErrorLines(issues), issues: issues },
        };
    }
    var json;
    try {
        json = JSON.parse(source);
    }
    catch (e) {
        var formatted = formatJsonParseError(source, e);
        var loc = locateJsonError(source, e);
        var issues = [
            issue("line ".concat(loc.line, ", column ").concat(loc.column), formatted.replace(/^JSON parse error at line \d+, column \d+:\s*/, '').split('\n')[0], 'parse'),
        ];
        return {
            json: null,
            validation: {
                valid: false,
                errors: [formatted],
                issues: issues,
            },
        };
    }
    var validation = validateSceneJSON(json, __assign({ strictTypes: false }, options));
    return {
        json: json,
        validation: validation,
    };
}
